import { ComputedSerie, CustomLayerProps, Serie } from "@nivo/line";
import { computeXYScalesForSeries } from "@nivo/scales";
import { useMemo } from "react";
import { LineWithTooltip } from "src/components/monitoring/senec-state-history-chart/LineWithTooltip";
import { LineData } from "src/components/monitoring/senec-state-history-chart/stateHistoryTypes";

interface SerieDatum {
    x: number | string | Date;
    xStacked?: number | null;
    y: number | string | Date;
    yStacked?: number | null;
}

export const Lines = ({
    lineChartData,
    onLineClick,
    serieData,
}: {
    lineChartData: CustomLayerProps;
    serieData: Serie[];
    onLineClick: (data: LineData) => void;
}) => {
    const { series: rawSeries } = useMemo(() => {
        const data = serieData.map((s) => ({ ...s, data: s.data.map((_s) => _s as SerieDatum) }));
        return computeXYScalesForSeries(
            data,
            lineChartData.xScale,
            lineChartData.yScale,
            lineChartData.innerWidth,
            lineChartData.innerHeight,
        );
    }, [lineChartData, serieData]);

    const { series } = useMemo(() => {
        const dataWithLabel = serieData.map((line) => ({
            ...line,
            label: line.id,
        }));
        const series = dataWithLabel
            .map((datum) => ({
                ...rawSeries.find((serie) => serie.id === datum.id),
            }))
            .filter((item) => Boolean(item.id)) as never as ComputedSerie[];

        return { series };
    }, [lineChartData, rawSeries]);

    const minX = series.at(0)!.data[0].position.x;
    const minY = series.at(0)!.data[0].position.y;
    const maxX = series.at(-1)!.data[1].position.x;
    const maxY = series.at(-1)!.data[1].position.y;

    return series
        .slice(0)
        .reverse()
        .map((serie) => (
            <LineWithTooltip
                serie={serie}
                key={serie.id}
                // @ts-expect-error using custom tooltip props here - if you know how to type this correctly, please do
                tooltip={lineChartData.tooltip}
                marginLeft={lineChartData.margin?.left || 0}
                marginTop={lineChartData.margin?.top || 0}
                onLineClick={onLineClick}
                maxValues={{
                    minX,
                    minY,
                    maxX,
                    maxY,
                }}
            />
        ));
};
